angular.module('acme.common.service.customerServiceApi', [
  'acme.common.factory.QueryStringBuilder'
])
.service('CustomerServiceApiService', [ '$http', 'QueryStringBuilderFactory', function ($http, QueryStringBuilderFactory) {

  return {

    service: '',

    init: function (endpoint) {
      this.service = endpoint + '/sherpa';
      return this;
    },

    search: function(props) {
      var q = '';

      if (props) {
        var qs = new QueryStringBuilderFactory({
          props: props,
          fields: {
            optional: ['pageSize', 'page', 'search', 'sortField', 'sortDirection', 'startDate', 'endDate']
          }
        });
        q = qs.query;
      }

      return $http({
        method: 'get',
        url: this.service + '/orders/search' + q
      });
    },

    listTenants: function () {
      return $http({
        method: 'get',
        url: this.service + '/tenants'
      });
    },

    listCustomers: function() {
      return $http({
        method: 'get',
        url: this.service + '/visitors'
      });
    },

    searchCustomers: function(like, emailLike) {
      return $http({
        method: 'get',
        url: this.service + '/visitors?like=' + like + '&emailLike=' + emailLike
      });
    },

    getAllOrders: function() {
      return $http({
        method: 'get',
        url: this.service + '/orders'
      });
    },

    getOrder: function(id) {
      return $http({
        method: 'get',
        url: this.service + '/orders/' + id
      });
    },

    getOrdersForTenant: function(id) {
      return $http({
        method: 'get',
        url: this.service + '/orders?tenantId=' + id
      });
    },

    getOrdersForTenantLike: function(id, like, emailLike) {
      return $http({
        method: 'get',
        url: this.service + '/orders?tenantId=' + id + '&like=' + like + '&emailLike=' + emailLike
      });
    },

    getOrdersLike: function(like, emailLike) {
      var queries = [],
        q = '';

      if (like) {
        queries.push('like=' + like);
      }

      if (emailLike) {
        queries.push('emailLike=' + emailLike);
      }

      if (queries.length > 0) {
        q = '?'+queries.join('&');
      }

      return $http({
        method: 'get',
        url: this.service + '/orders' + q
      });
    },

    getOrdersForVisitor: function(id) {
      return $http({
        method: 'get',
        url: this.service + '/orders?visitorId=' + id
      });
    },

    getOrdersForVisitorLike: function(id, like, emailLike) {
      return $http({
        method: 'get',
        url: this.service + '/orders?visitorId=' + id  + '&like=' + like
      });
    },

    cron: function() {
      return $http({
        method: 'get',
        url: '/v1/api/cron'
      });
    },

    deputySignIn: function(tenantId) {
      return $http({
        method: 'get',
        url: this.service + '/tenants/' + tenantId + '/deputy'
      });
    },

    getTenantB2BActivity: function(tenantId, deputyId) {
      var url = this.service + '/b2blog';
      var added = false;

      if (tenantId && tenantId !== '') {
        added = true;
        url = url + '?tenantId=' + tenantId;
      }

      if (deputyId && deputyId !== '') {
        if (added) {
          url = url + '&deputyId=' + deputyId;
        } else {
          url = url + '?deputyId=' + deputyId;
          added = true;
        }
      }

      return $http({
        method: 'get',
        url: url
      });
    },

    getTenantB2CActivity: function(tenantId, deputyId) {
      var url = this.service + '/b2clog';
      var added = false;

      if (tenantId && tenantId !== '') {
        added = true;
        url = url + '?tenantId=' + tenantId;
      }

      if (deputyId && deputyId !== '') {
        if (added) {
          url = url + '&deputyId=' + deputyId;
        } else {
          url = url + '?deputyId=' + deputyId;
          added = true;
        }
      }

      return $http({
        method: 'get',
        url: url
      });
    },

    refund : function(refundObject) {
      return $http({
        method: 'post',
        url: '/v1/b2b/refunds'
      });

    }
  };

}]);
